import { render, staticRenderFns } from "./Csapolt.vue?vue&type=template&id=0afd2a6a&"
import script from "./Csapolt.vue?vue&type=script&lang=js&"
export * from "./Csapolt.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports